$(function () {
    'use strict';

    function pswp(container, element, trigger, caption, isGallery) {
        var parseThumbnailElements = function (el) {
            var items = [],
                gridEl,
                linkEl,
                item;

            $(el)
                .find(element)
                .each(function (i, v) {
                    gridEl = $(v);
                    linkEl = gridEl.find(trigger);

                    item = {
                        src: isGallery
                            ? gridEl.find('img').attr('src')
                            : linkEl.attr('href'),
                        w: 0,
                        h: 0,
                    };

                    if (caption && gridEl.find(caption).length) {
                        item.title = gridEl.find(caption).html();
                    }

                    items.push(item);
                });

            return items;
        };

        var openPhotoSwipe = function (index, galleryElement) {
            var pswpElement = document.querySelectorAll('.pswp')[0],
                gallery,
                options,
                items;

            items = parseThumbnailElements(galleryElement);

            options = {
                closeOnScroll: false,
                history: false,
                index: index,
                shareEl: false,
                showAnimationDuration: 0,
                showHideOpacity: true,
            };

            gallery = new PhotoSwipe(
                pswpElement,
                PhotoSwipeUI_Default,
                items,
                options
            );
            gallery.listen('gettingData', function (index, item) {
                if (item.w < 1 || item.h < 1) {
                    var img = new Image();
                    img.onload = function () {
                        item.w = this.width;
                        item.h = this.height;
                        gallery.updateSize(true);
                    };
                    img.src = item.src;
                }
            });
            gallery.init();
        };

        var onThumbnailsClick = function (e) {
            e.preventDefault();

            var index = $(e.target)
                .closest(container)
                .find(element)
                .index($(e.target).closest(element));
            var clickedGallery = $(e.target).closest(container);

            openPhotoSwipe(index, clickedGallery[0]);

            return false;
        };

        $(container).on('click', trigger, function (e) {
            onThumbnailsClick(e);
        });
    }

    function gallery() {
        pswp(
            '.kg-gallery-container',
            '.kg-gallery-image',
            '.kg-gallery-image',
            false,
            true
        );
    }

    gallery();
});
